import { AppState } from '../types/store';

export const getJoinState = (state: AppState) => state.join;
